var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import { NikeI18nConsumer } from '../nike-i18n-provider';
const TranslatableString = (props) => {
    const { description, icuOptions, icuTokens, primaryValue, stringKey, element } = props, rest = __rest(props, ["description", "icuOptions", "icuTokens", "primaryValue", "stringKey", "element"]);
    return (React.createElement(NikeI18nConsumer, null, ({ i18nString, defaultElement }) => {
        const pureString = i18nString({
            stringKey,
            description,
            primaryValue,
            icuOptions,
            icuTokens,
        });
        // Allow user to request pure string output by passing element={null}
        if (element === null || (defaultElement === null && element === undefined)) {
            return pureString;
        }
        const finalProps = Object.assign(Object.assign({}, rest), { dangerouslySetInnerHTML: {
                __html: pureString,
            } });
        return createElement(element || defaultElement, finalProps);
    }));
};
TranslatableString.defaultProps = {
    description: null,
    icuOptions: null,
    icuTokens: null,
    element: undefined,
};
TranslatableString.propTypes = {
    description: PropTypes.string,
    // icuOptions doesn't have a predictable shape
    // eslint-disable-next-line react/forbid-prop-types
    icuOptions: PropTypes.object,
    // icuTokens doesn't have a predictable shape
    // eslint-disable-next-line react/forbid-prop-types
    icuTokens: PropTypes.object,
    primaryValue: PropTypes.string.isRequired,
    stringKey: PropTypes.string.isRequired,
    element: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.elementType,
    ]),
};
export default TranslatableString;
//# sourceMappingURL=translatable-string.js.map